import { DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutZoneArea extends Layout {
    dataheaderZoneArea: DataHeader;
    panelZoneArea: Panel;
    sourceZoneArea: DataSource;
    textboxDescription: Textbox;
    textboxId: Textbox;
    textboxZoneRegionId: Textbox;
}
